var AllowedUserActionItem = /* @__PURE__ */ ((AllowedUserActionItem2) => {
  AllowedUserActionItem2["TOGGLE"] = "TOGGLE";
  AllowedUserActionItem2["DELETE"] = "DELETE";
  AllowedUserActionItem2["CHANGE_QUANTITY"] = "CHANGE_QUANTITY";
  AllowedUserActionItem2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  AllowedUserActionItem2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  AllowedUserActionItem2["OPEN_PRODUCT_DETAIL"] = "OPEN_PRODUCT_DETAIL";
  AllowedUserActionItem2["ADD_NOTE"] = "ADD_NOTE";
  return AllowedUserActionItem2;
})(AllowedUserActionItem || {});
var UserActionType = /* @__PURE__ */ ((UserActionType2) => {
  UserActionType2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  UserActionType2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  UserActionType2["USE_DEFERRED_PAYMENT"] = "USE_DEFERRED_PAYMENT";
  UserActionType2["USE_DEPOSIT"] = "USE_DEPOSIT";
  UserActionType2["ADD_CONSULTANT"] = "ADD_CONSULTANT";
  UserActionType2["REQUEST_NEW_SKU"] = "REQUEST_NEW_SKU";
  UserActionType2["CREATE_QUOTATION"] = "CREATE_QUOTATION";
  return UserActionType2;
})(UserActionType || {});
var CartDeliveryType = /* @__PURE__ */ ((CartDeliveryType2) => {
  CartDeliveryType2["DELIVERY_TYPE_UNSPECIFIED"] = "DELIVERY_TYPE_UNSPECIFIED";
  CartDeliveryType2["DELIVERY_TYPE_AT_HOME"] = "DELIVERY_TYPE_AT_HOME";
  CartDeliveryType2["DELIVERY_TYPE_PICKUP"] = "DELIVERY_TYPE_PICKUP";
  CartDeliveryType2["DELIVERY_TYPE_HANDOVER"] = "DELIVERY_TYPE_HANDOVER";
  return CartDeliveryType2;
})(CartDeliveryType || {});
var CheckoutAllowedUserActions = /* @__PURE__ */ ((CheckoutAllowedUserActions2) => {
  CheckoutAllowedUserActions2["PAYMENT"] = "PAYMENT";
  CheckoutAllowedUserActions2["FINISH"] = "FINISH";
  CheckoutAllowedUserActions2["ORDER_LIST"] = "ORDER_LIST";
  CheckoutAllowedUserActions2["QUOTATION_POPUP"] = "QUOTATION_POPUP";
  return CheckoutAllowedUserActions2;
})(CheckoutAllowedUserActions || {});
var DeliveryTimeSlotType = /* @__PURE__ */ ((DeliveryTimeSlotType2) => {
  DeliveryTimeSlotType2["REQUIRED"] = "REQUIRED";
  DeliveryTimeSlotType2["OPTIONAL"] = "OPTIONAL";
  DeliveryTimeSlotType2["NONE"] = "NONE";
  return DeliveryTimeSlotType2;
})(DeliveryTimeSlotType || {});
var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["INDIVIDUAL"] = "INDIVIDUAL";
  CustomerType2["FOREIGN"] = "FOREIGN";
  CustomerType2["BUSINESS"] = "BUSINESS";
  CustomerType2["STATE_BUDGET_UNIT"] = "STATE_BUDGET_UNIT";
  return CustomerType2;
})(CustomerType || {});
var PromotionGroupType = /* @__PURE__ */ ((PromotionGroupType2) => {
  PromotionGroupType2["GROUP_TYPE_DEFAULT"] = "GROUP_TYPE_DEFAULT";
  PromotionGroupType2["GROUP_TYPE_SELECTABLE"] = "GROUP_TYPE_SELECTABLE";
  PromotionGroupType2["GROUP_TYPE_EXCLUSIVE"] = "GROUP_TYPE_EXCLUSIVE";
  PromotionGroupType2["GROUP_TYPE_TIER_PROMOTIONS"] = "GROUP_TYPE_TIER_PROMOTIONS";
  return PromotionGroupType2;
})(PromotionGroupType || {});
var RequiredInfoToCheckout = /* @__PURE__ */ ((RequiredInfoToCheckout2) => {
  RequiredInfoToCheckout2["DELIVERY_EMAIL"] = "DELIVERY_EMAIL";
  RequiredInfoToCheckout2["DELIVERY_PHONE"] = "DELIVERY_PHONE";
  return RequiredInfoToCheckout2;
})(RequiredInfoToCheckout || {});

export { AllowedUserActionItem, CartDeliveryType, CheckoutAllowedUserActions, CustomerType, DeliveryTimeSlotType, PromotionGroupType, RequiredInfoToCheckout, UserActionType };
